import axios from "axios";

import { getHeader, getAuthHeader } from "../headers";

// ===================================================================================
//  GET ORGANIZATIONS
// ===================================================================================
export const organizationsLoading = () => {
	return {
		type: "ORGANIZATIONS_IS_LOADING"
	};
};

export const organizationsError = err => {
	return {
		type: "ORGANIZATIONS_HAS_ERROR",
		err
	};
};

export const organizationsSuccess = data => {
	return {
		type: "ORGANIZATIONS_SUCCESS",
		data
	};
};

export function getOrganizations() {
	return dispatch => {
		dispatch(organizationsLoading());

		return axios
			.get(process.env.REACT_APP_API_URL + "organizations", {
				headers: getHeader()
			})
			.then(response => {
				if (response.data.status && response.data.status !== 200) {
					dispatch(organizationsError(response.data.errors));
				} else {
					dispatch(organizationsSuccess(response.data));
					return Promise.resolve(response);
				}
			})
			.catch(err => {
				dispatch(organizationsError(err.response.data.message));
			});
	};
}

// ===================================================================================
//  GET SINGLE ORGANIZATION
// ===================================================================================
export const organizationSingleLoading = () => {
	return {
		type: "ORGANIZATION_SINGLE_IS_LOADING"
	};
};

export const organizationSingleError = err => {
	return {
		type: "ORGANIZATION_SINGLE_HAS_ERROR",
		err
	};
};

export const organizationSingleSuccess = data => {
	return {
		type: "ORGANIZATION_SINGLE_SUCCESS",
		data
	};
};

export function getSingleOrganization(id, isAdmin = false) {
	return (dispatch, getState) => {
		dispatch(organizationSingleLoading());

		return axios
			.get(process.env.REACT_APP_API_URL + `organizations/${id}`, {
				headers: getAuthHeader(getState().user, isAdmin)
			})
			.then(response => {
				if (response.data.status && response.data.status !== 200) {
					dispatch(organizationSingleError(response.data.errors));
				} else {
					dispatch(organizationSingleSuccess(response.data));
					return Promise.resolve(response);
				}
			})
			.catch(err => {
				dispatch(organizationSingleError(err.response.data.message));
			});
	};
}



// WEBPACK FOOTER //
// ./src/store/actions/organizations.js